import React from "react";
import Loadable from "../../react-loadable";
const colors = [
  "#4DB4FF",
  "#1477B4",
  "#49AFBC",
  "#B6CF21",
  "#F9A825",
  "#FF81AC",
  "#AF64F0",
  "#808BC5",
  "#5C6977",
  "#BEBEBE"
];

const WeaEchart = Loadable({
  loader: () => import("./Echart"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});

WeaEchart.colors = colors;

export default WeaEchart;



// WEBPACK FOOTER //
// ./ecology9/wea-echart/index.js